/* eslint-disable max-len */
import React from 'react'

const AttendanceDropdown = ({handleDropdownChange, session, selectedItem, selectedIndex}) => {
    const AttendaceType = ["Present", "Absent"]
    return (
        <ul class={`ant-picker-dropdown slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block`}
            aria-labelledby="dropdownMenu_acdemic_year"
            data-te-dropdown-menu-ref>
            <li class="max-h-[150px] overflow-auto scroll-bar">
                <ul>
                    {AttendaceType.map((itemType) => (
                        <li key={itemType}>
                            <p class="cursor-pointer block w-full whitespace-nowrap bg-white px-2 pt-2 mb-0.5 text-f7 font-normal text-[#031624] selected_Class"
                                data-te-dropdown-item-ref
                                onClick={() => handleDropdownChange(selectedIndex,selectedItem,session,itemType.toLowerCase())}
                            >
                                {itemType}
                            </p>
                        </li>))}
                </ul>
            </li>
        </ul>
    )
}

export default AttendanceDropdown